<template>
    <transition name="fade" mode="out-in">
        <div class="dynamic-modal-wrapper" v-if="showModal">
            <div class="dynamic-modal-bg"></div>
            <div class="dynamic-modal-outer">
                <div class="dynamic-modal-close" @click="closeDynamicModal">
                    <font-awesome-icon :icon="['fal', 'times-circle']" />
                </div>

                <dynamic-template :template="`<div class='client-content'>${dynamicModal.content}</div>`" />

                <div class="d-flex justify-content-between align-items-center px-4 py-2 bg-light">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="modalHideForCheckbox" id="modalOnehideFor">
                        <label class="form-check-label unselectable" for="modalOnehideFor">
                            Hide this message for one week
                        </label>
                    </div>
                    <button type="button" class="button-outline-rounded" @click="closeDynamicModal">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import dynamicTemplate from 'v-runtime-template';
import dayjs from 'dayjs';

export default {
    name: 'dynamic-config-modal',
    components: {
        dynamicTemplate,
    },
    data () {
        return {
            showModal: false,
            modalVisitCount: 0,
            modalHideForCheckbox: false,
        };
    },
    computed: {
        dynamicModal () {
            return this.$store.state.clientConfig.dynamicModal;
        },
        dynamicModalIsHidden () {
            if (this.dynamicModal.hideAfter.value === null) return false;
            return this.modalVisitCount > this.dynamicModal.hideAfter.value;
        },

    },
    methods: {
        closeDynamicModal () {
            this.showModal = false;
            const hibernationValue = this.modalHideForCheckbox
                ? dayjs().add(1, 'week').valueOf()
                : dayjs().add(this.dynamicModal.hibernate.value, this.dynamicModal.hibernate.unit).valueOf();
            localStorage.setItem('hibernate-dynamic-modal-1', hibernationValue);
        },
        updateModalVisitCount () {
            const count = localStorage.getItem('modal-visit-count');
            if (count && !Number.isNaN(count)) {
                this.modalVisitCount = Number(count) + 1;
            } else {
                this.modalVisitCount = 1;
            }
            localStorage.setItem('modal-visit-count', this.modalVisitCount);
        },
        checkShowModal (newValue) {
            const showRule = this.dynamicModal.showAfter;
            const hibernationRule = localStorage.getItem('hibernate-dynamic-modal-1');
            if (!this.dynamicModalIsHidden) {
                if (this.shouldShowModal(showRule, hibernationRule, newValue)) {
                    this.showModal = true;
                }
            }
        },
        shouldShowModal (showRule, hibernationRule, newValue) {
            const currentTime = dayjs().valueOf();
            if (showRule) {
                if (showRule.value === 0 || this.modalVisitCount > showRule.value) {
                    return this.checkHibernateRule(hibernationRule, newValue, currentTime);
                }
            } else {
                return this.checkHibernateRule(hibernationRule, newValue, currentTime);
            }
            return false;
        },
        checkHibernateRule (hibernationRule, newValue, currentTime) {
            if (hibernationRule) {
                if (hibernationRule < currentTime) {
                    return true;
                }
                if (!newValue.hibernate) {
                    localStorage.removeItem('hibernate-dynamic-modal-1');
                    return true;
                }
            } else {
                return true;
            }
            return false;
        },

    },
    watch: {
        dynamicModal: {
            handler (newValue, oldValue) {
                if (newValue && JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
                    this.updateModalVisitCount();
                    this.checkShowModal(newValue);
                }
            },
            immediate: true,
        },

    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";

.dynamic-modal-wrapper {
    z-index: 15;
    position: fixed;

    .dynamic-modal-bg {
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        position: fixed;
        background: rgba(0, 0, 0, 0.2);

        /* if backdrop support: very transparent and blurred */
        @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
            filter: blur(4px);
            backdrop-filter: blur(8px) grayscale(0.1);
        }
    }

    .dynamic-modal-outer {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        background: white;

        border-radius: 6px;

        .dynamic-modal-close {
            box-shadow: $boxShadow;
            font-size: 26px;
            line-height: 33px;
            position: absolute;
            right: -10px;
            top: -10px;
            width: 35px;
            height: 35px;
            text-align: center;
            background: white;
            border-radius: 50%;
            cursor: pointer;
        }

        .client-content {
            width: 50vw;
            max-height: 80dvh;
            overflow: auto;
            padding: 1.5rem;

            ::v-deep.heading-with-underline {
                font-size: 30px;

                &::after {
                    top: 45px;
                }
            }

            @include responsive("md") {
                width: 90vw;
            }

        }
    }
}

.unselectable {
    -webkit-user-select: none;
    /* Safari */
    -ms-user-select: none;
    /* IE 10+ */
    user-select: none;
}

.form-check-label {
    font-size: 1rem !important;

}
</style>
